import tw from 'tailwind-styled-components'

export const SRBigCalendarEventDayStyle = tw.div`
  flex
  flex-col
  h-full
  text-sm
  justify-between p-4
  
`

export const SRBigCalendarEventDayBlockStyle = tw.div`
  flex
  flex-col
  gap-1
  items-center
`
